import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'

import {
  TableHeader,
  TableHeaderItem,
  TablePelaksanaanKinerja,
  TableBody,
  TableRow,
  TableRowItem,
  TableShimmer,
} from 'app/KinerjaShared/components/TablePelaksanaanKinerja'
import StateEmpty from 'app/KinerjaShared/components/StateEmpty'
import { PENGELOLAAN_KINERJA_BASE_PATH } from 'app/KinerjaShared/constants/path'
import * as PelaksanaanBadge from 'app/KinerjaTimPenilaiPSPage/components/ExecutionStatusBadges'

import type { TPelaksanaanPSListItem } from 'types/kinerja-tim-penilai-ps'

type Props = {
  data: TPelaksanaanPSListItem[]
  isLoading?: boolean
  className?: string
  basePath?: string
}

const isAllEvaluated = (data: TPelaksanaanPSListItem) =>
  data.praktikKinerjaPelaksanaanStatus === 'SELESAI' &&
  data.perilakuKerjaPelaksanaanStatus === 'SUDAH_DINILAI' &&
  data.pengembanganKompetensiPelaksanaanStatus === 'SUDAH_REFLEKSI'

export default function TablePelaksanaanPS({
  data,
  isLoading = false,
  className,
  basePath = PENGELOLAAN_KINERJA_BASE_PATH,
}: Props) {
  const isEmpty = data.length === 0

  return (
    <TablePelaksanaanKinerja className={className}>
      <TableHeader>
        <TableHeaderItem>Nama</TableHeaderItem>
        <TableHeaderItem>Status Praktik Kinerja</TableHeaderItem>
        <TableHeaderItem>Status Perilaku Kerja</TableHeaderItem>
        <TableHeaderItem>Status Pengembangan Kompetensi</TableHeaderItem>
        <TableHeaderItem></TableHeaderItem>
      </TableHeader>
      <TableBody>
        {isLoading && <TableShimmer />}
        {!isLoading &&
          (isEmpty ? (
            // if no data found for certain state
            <TableRow>
              <TableRowItem colSpan={5}>
                <StateEmpty>
                  Pastikan terdapat Perencanaan dengan status tersebut
                </StateEmpty>
              </TableRowItem>
            </TableRow>
          ) : (
            // if data exists
            data.map((data) => (
              <TableRow key={data.skpPsId}>
                <TableRowItem className="w-2/12">
                  {data.namaPengawas}
                </TableRowItem>
                <TableRowItem className="w-3/12">
                  <PelaksanaanBadge.PraktikKinerja
                    state={data.praktikKinerjaPelaksanaanStatus}
                  />
                </TableRowItem>
                <TableRowItem className="w-2/12">
                  <PelaksanaanBadge.PerilakuKerja
                    state={data.perilakuKerjaPelaksanaanStatus}
                  />
                </TableRowItem>
                <TableRowItem className="w-3/12">
                  <PelaksanaanBadge.PengembanganKompetensi
                    state={data.pengembanganKompetensiPelaksanaanStatus}
                  />
                </TableRowItem>
                <TableRowItem>
                  <Link
                    passHref
                    href={`${basePath}/penilai/pelaksanaan/${data.skpPsId}`}
                  >
                    <Button
                      as="a"
                      className="!inline-flex"
                      size="sm"
                      color={isAllEvaluated(data) ? 'white' : 'black'}
                    >
                      {isAllEvaluated(data) ? 'Cek' : 'Lakukan'}
                    </Button>
                  </Link>
                </TableRowItem>
              </TableRow>
            ))
          ))}
      </TableBody>
    </TablePelaksanaanKinerja>
  )
}
